export default __webpack_public_path__ + "static/media/logo-menu-scroll.71cd6d82.png";